'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

require('../styles/StaffTakeoverMessage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaffTakeoverMessage = function StaffTakeoverMessage(_ref) {
  var intl = _ref.intl,
      name = _ref.name;
  return _react2.default.createElement(
    'div',
    { className: 'cp-staff-takeover-message' },
    _react2.default.createElement(
      'h2',
      null,
      intl.formatHTMLMessage({ id: 'staffTakeoverMessage' }, {
        name: name
      }),
      '\xA0',
      _react2.default.createElement(
        'a',
        { href: '/user/reset_admin_session' },
        intl.formatMessage({ id: 'resetStaffSessionLink' })
      )
    )
  );
};

StaffTakeoverMessage.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  name: _react.PropTypes.string.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(StaffTakeoverMessage);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-staff-takeover-message/lib/components/StaffTakeoverMessage.component.js
// module id = 1509
// module chunks = 1